enum HttpMethod {
  GET = 0,
  POST = 1,
  DELETE = 2,
  PATCH = 3,
  PUT = 4,
}

export default HttpMethod;
